import { Icon } from "@/components/Icons/Icon";

export const AppleLogoIcon = () => <Icon src="/assets/apple-logo-icon.svg" imageSize={{ width: "24", height: "24" }} />;
